<template>
  <div class="list disk-share-records">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>网盘</Breadcrumb-item>
        <Breadcrumb-item>分享记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Table border :columns="columns" :data="list" :loading="loading" no-data-text="还没有分享记录"></Table>

    <Modal v-model="showLog" title="详细记录" width="720">
      <Table border :columns="logColumns" :data="logList" :loading="logLoading"
             no-data-text="还没有预览或下载"></Table>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'DiskShareRecords',
  data () {
    return {
      loading: false,
      list: [],
      showLog: false,
      logLoading: false,
      logList: [],
      columns: [
        {
          title: '文件',
          width: 320,
          render: (h, params) => {
            let name = params.row.nodeName || ''
            let url = this.buildShareUrl(params.row.token, params.row.extractCode)
            return h('a', {
              attrs: {href: url, target: '_blank', rel: 'noopener', title: name},
              style: {display: 'inline-block', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-all', lineHeight: '20px'}
            }, name)
          }
        },
        {title: '分享人', width: 100, key: 'creatorName'},
        {
          title: '分享时间',
          width: 170,
          render: (h, params) => h('span', this.formatTime(params.row.gmtCreate))
        },
        {
          title: '到期时间',
          width: 170,
          render: (h, params) => h('span', params.row.expireTime ? this.formatTime(params.row.expireTime) : '永久')
        },
        {
          title: '提取码',
          width: 90,
          align: 'center',
          render: (h, params) => h('span', params.row.extractCode || '无')
        },
        {
          title: '状态',
          width: 90,
          align: 'center',
          render: (h, params) => h('span', this.statusText(params.row))
        },
        {title: '访问次数', width: 90, align: 'center', key: 'visitCount'},
        {title: '预览次数', width: 90, align: 'center', key: 'previewCount'},
        {title: '下载次数', width: 90, align: 'center', key: 'downloadCount'},
        {
          title: '操作',
          width: 220,
          align: 'center',
          render: (h, params) => {
            let links = [
              h('a', {
                style: {marginRight: '16px'},
                on: {click: () => this.copyText(this.buildShareUrl(params.row.token, params.row.extractCode))}
              }, '复制'),
              h('a', {
                style: {marginRight: params.row.status === 1 ? '16px' : '0'},
                on: {click: () => this.openLog(params.row)}
              }, '详细记录')
            ]
            if (params.row.status === 1) {
              links.push(h('a', {on: {click: () => this.revoke(params.row)}}, '撤销'))
            }
            return h('div', links)
          }
        }
      ],
      logColumns: [
        {title: '访问 IP', minWidth: 140, key: 'ip'},
        {
          title: '访问时间',
          width: 170,
          render: (h, params) => h('span', this.formatTime(params.row.gmtCreate))
        },
        {title: '预览次数', width: 100, align: 'center', key: 'previewCount'},
        {title: '下载次数', width: 100, align: 'center', key: 'downloadCount'}
      ]
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      let self = this
      self.loading = true
      self.$http.get('/disk/share/all').then(function (res) {
        self.loading = false
        if (res && res.status === 'ok') {
          self.list = res.data || []
        }
      }).catch(function () {
        self.loading = false
      })
    },
    statusText (row) {
      if (!row || row.status !== 1) {
        return '已撤销'
      }
      if (row.expireTime && this.$moment(row.expireTime).isBefore(this.$moment())) {
        return '已过期'
      }
      return '有效'
    },
    formatTime (value) {
      if (value == null || value === '') {
        return ''
      }
      if (typeof value === 'number') {
        return this.$moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
      let text = String(value)
      if (/^\d{10,}$/.test(text)) {
        return this.$moment(Number(text)).format('YYYY-MM-DD HH:mm:ss')
      }
      return text
    },
    buildShareUrl (token, extractCode) {
      let url = window.location.origin + window.location.pathname + '#/disk/share?token=' + (token || '')
      if (extractCode) {
        url += '&extractCode=' + extractCode
      }
      return url
    },
    copyText (text) {
      let input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$Message.success('已复制')
      } catch (e) {
        this.$Message.error('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    },
    openLog (row) {
      let self = this
      if (!row) {
        return
      }
      self.logList = []
      self.logLoading = true
      self.showLog = true
      self.$http.get('/disk/share/access', {params: {id: row.id}}).then(function (res) {
        self.logLoading = false
        if (res && res.status === 'ok') {
          self.logList = res.data || []
        }
      }).catch(function () {
        self.logLoading = false
      })
    },
    revoke (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定撤销该分享链接吗？',
        onOk: function () {
          self.$http.post('/disk/share/revoke', {id: row.id}).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已撤销')
              self.load()
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.disk-share-records /deep/ .ivu-table td {
  height: auto;
}
.disk-share-records /deep/ .ivu-table-cell {
  overflow: visible;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// DiskShareRecords.vue?95bb5cde